import React from 'react'
import logo from "../../assets/logo.svg";
import "./StockistReportHeader.css"; 

const StockistReportHeader = () => {
  return (
    <header className="stockistreport-header"> 
      <div className="stockistreport-header-logo">
        <img className="stockistreport-header-logo-img" src={logo} alt="logo" />
      </div>      
    </header>
  )
}

export default StockistReportHeader